import { render, staticRenderFns } from "./confirmRecord.vue?vue&type=template&id=4819efec&scoped=true&"
import script from "./confirmRecord.vue?vue&type=script&lang=js&"
export * from "./confirmRecord.vue?vue&type=script&lang=js&"
import style0 from "./confirmRecord.vue?vue&type=style&index=0&id=4819efec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4819efec",
  null
  
)

export default component.exports